import classNames from 'classnames';
import { FC, memo } from 'react';
import { GameData, useThrottle } from 'react-easyrocket';
import { GameBadges } from './components/GameBadges';
import { GameControls } from './components/GameControls';
import { GameGradient } from './components/GameGradient';
import { AddFavoriteButton } from './components/AddFavoriteButton';
import { useGameHandleClick } from './utils/useGameHandleClick';
import { GameImage } from '../GameImage';

interface GameProps {
  game: GameData;
  isWagering?: boolean;
  className?: string;
  showGameInfo?: boolean;
  onClick?: () => void;
  is150?: boolean;
  is140?: boolean;
  is120?: boolean;
  is100?: boolean;
  showAddfavorite?: boolean;
  heartIconSize?: string;
}

const _GameCard: FC<GameProps> = ({
  game,
  className,
  onClick,
  showAddfavorite = true,
  heartIconSize
}) => {
  const isGameGradient = Boolean(game.imagine?.gradient_color);

  const { isFavorite, toggleFavorite } = useGameHandleClick({
    game: game
  });
  const handleThrottleAddFavorite = useThrottle(toggleFavorite, 500);

  if (!game.image) {
    return null;
  }

  return (
    <div
      className={classNames(
        'game-card group relative z-0 cursor-pointer w-full aspect-[29/40] rounded-lg overflow-hidden h-auto',
        className
      )}>
      {showAddfavorite && (
        <AddFavoriteButton
          handleThrottleAddFavorite={handleThrottleAddFavorite}
          isFavorite={isFavorite}
          heartIconSize={heartIconSize}
        />
      )}
      {isGameGradient && <GameGradient game={game} />}
      <GameImage
        game={game}
        className="relative z-[2] w-full h-full rounded-lg border object-fill border-solid border-gc_border "
      />
      {game && <GameBadges gameCategories={game.categories || []} />}
      <GameControls
        game={game}
        onClick={onClick}
        showAddfavorite={showAddfavorite}
        heartIconSize={heartIconSize}
      />
    </div>
  );
};

export const GameCard = memo(_GameCard);
